/**
 * MP Amenities — Premium HTML quote emails.
 * Gmail : déployer assets/mp-quote-gmail-webhook.gs sur Google Apps Script.
 */
(function (global) {
  'use strict';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function row(label, value, link) {
    if (!value) return '';
    var valueHtml = escapeHtml(value);
    if (link === 'email') {
      valueHtml = '<a href="mailto:' + escapeHtml(value) + '" style="color:#141820;text-decoration:none;font-weight:600;">' + valueHtml + '</a>';
    }
    if (link === 'tel') {
      valueHtml = '<a href="tel:' + escapeHtml(value).replace(/\s/g, '') + '" style="color:#141820;text-decoration:none;font-weight:600;">' + valueHtml + '</a>';
    }
    return (
      '<tr>' +
      '<td style="padding:14px 16px;background:#fafafa;border-bottom:1px solid #ececec;width:36%;vertical-align:top;border-radius:8px 0 0 8px;">' +
      '<span style="font-family:Arial,Helvetica,sans-serif;font-size:10px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#8a8a8a;">' +
      escapeHtml(label) +
      '</span></td>' +
      '<td style="padding:14px 16px;background:#ffffff;border-bottom:1px solid #ececec;vertical-align:top;border-radius:0 8px 8px 0;">' +
      '<span style="font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.5;color:#141820;">' +
      valueHtml +
      '</span></td>' +
      '</tr>' +
      '<tr><td colspan="2" style="height:6px;font-size:0;line-height:0;">&nbsp;</td></tr>'
    );
  }

  function buildHtml(data) {
    var now = new Date();
    var dateStr = now.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    var timeStr = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

    var rows =
      row(data.labelName || 'Nom', data.name) +
      row(data.labelEmail || 'Email', data.email, 'email') +
      row(data.labelPhone || 'Téléphone', data.phone, 'tel') +
      row(data.labelCompany || 'Établissement', data.company) +
      row(data.labelProperty || 'Type établissement', data.property) +
      row(data.labelCategory || 'Catégorie produits', data.category) +
      row(data.labelQuantity || 'Quantité estimée', data.quantity) +
      row(data.labelLogo || 'Personnalisation logo', data.logo) +
      row(data.labelSource || 'Source', data.source);

    var messageBlock = data.message
      ? '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin-top:8px;">' +
        '<tr><td style="padding:20px 22px;background:linear-gradient(135deg,#faf8f5 0%,#f3f3f3 100%);border:1px solid #e8e0d4;border-left:4px solid #C5A059;border-radius:10px;">' +
        '<p style="margin:0 0 10px;font-family:Arial,Helvetica,sans-serif;font-size:10px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#8a7340;">' +
        escapeHtml(data.labelMessage || 'Message client') +
        '</p>' +
        '<p style="margin:0;font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.7;color:#141820;white-space:pre-wrap;">' +
        escapeHtml(data.message) +
        '</p></td></tr></table>'
      : '';

    return (
      '<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>' +
      escapeHtml(data.title || 'Demande de devis') +
      '</title></head>' +
      '<body style="margin:0;padding:0;background:#e8e8e8;-webkit-font-smoothing:antialiased;">' +
      '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#e8e8e8;padding:40px 16px;">' +
      '<tr><td align="center">' +
      '<table role="presentation" width="620" cellpadding="0" cellspacing="0" style="max-width:620px;width:100%;background:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.12);">' +
      '<tr><td style="height:4px;background:linear-gradient(90deg,#C5A059 0%,#e8d5a8 50%,#C5A059 100%);font-size:0;line-height:0;">&nbsp;</td></tr>' +
      '<tr><td style="background:linear-gradient(145deg,#1e2433 0%,#141820 55%,#0d1018 100%);padding:36px 32px 32px;text-align:center;">' +
      '<table role="presentation" width="100%" cellpadding="0" cellspacing="0"><tr><td align="center">' +
      '<span style="display:inline-block;padding:6px 14px;background:rgba(197,160,89,0.18);border:1px solid rgba(197,160,89,0.45);border-radius:999px;font-family:Arial,Helvetica,sans-serif;font-size:9px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;color:#e8d5a8;">Nouveau devis</span>' +
      '<p style="margin:16px 0 0;font-family:Arial,Helvetica,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.32em;text-transform:uppercase;color:#C5A059;">MP AMENITIES</p>' +
      '<h1 style="margin:12px 0 0;font-family:Georgia,\'Times New Roman\',serif;font-size:32px;font-weight:500;color:#ffffff;line-height:1.15;">' +
      escapeHtml(data.title || 'Demande de devis') +
      '</h1>' +
      '<p style="margin:14px 0 0;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.55;color:rgba(255,255,255,0.78);">' +
      escapeHtml(data.subtitle || 'Nouvelle demande reçue depuis le site web') +
      '</p>' +
      '<p style="margin:18px 0 0;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:rgba(255,255,255,0.5);">' +
      escapeHtml(dateStr) + ' · ' + escapeHtml(timeStr) +
      '</p></td></tr></table></td></tr>' +
      '<tr><td style="padding:32px 28px 12px;">' +
      '<p style="margin:0 0 16px;font-family:Arial,Helvetica,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#141820;">Détails de la demande</p>' +
      '<table role="presentation" width="100%" cellpadding="0" cellspacing="0">' +
      rows +
      '</table>' +
      messageBlock +
      '</td></tr>' +
      '<tr><td style="padding:8px 28px 36px;">' +
      '<table role="presentation" width="100%" cellpadding="0" cellspacing="0"><tr><td align="center" style="padding-top:8px;">' +
      '<a href="mailto:' + escapeHtml(data.email) + '?subject=Re%3A%20Devis%20MP%20Amenities" style="display:inline-block;padding:14px 36px;background:#141820;color:#ffffff !important;text-decoration:none;font-family:Arial,Helvetica,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;border-radius:999px;box-shadow:0 8px 24px rgba(20,24,32,0.25);">Répondre au client</a>' +
      '</td></tr></table></td></tr>' +
      '<tr><td style="background:#f6f6f6;padding:22px 28px;text-align:center;border-top:1px solid #ececec;">' +
      '<p style="margin:0 0 6px;font-family:Arial,Helvetica,sans-serif;font-size:12px;font-weight:600;color:#141820;">MP Amenities</p>' +
      '<p style="margin:0;font-family:Arial,Helvetica,sans-serif;font-size:11px;line-height:1.65;color:#888888;">18 boulevard Mohamed VI · Casablanca<br>' +
      '<a href="mailto:anass@vinca.digital" style="color:#8a7340;text-decoration:none;">anass@vinca.digital</a></p>' +
      '</td></tr>' +
      '</table></td></tr></table></body></html>'
    );
  }

  var DEFAULT_RECIPIENT = 'anass@vinca.digital';
  var DEFAULT_RECIPIENT_2 = '';

  function buildPlainText(data, subject) {
    var lines = [
      subject || 'Nouvelle demande de devis — MP Amenities',
      '',
      (data.labelName || 'Nom') + ' : ' + (data.name || '—'),
      (data.labelEmail || 'Email') + ' : ' + (data.email || '—'),
      (data.labelPhone || 'Téléphone') + ' : ' + (data.phone || '—'),
      (data.labelCompany || 'Établissement') + ' : ' + (data.company || '—'),
      (data.labelProperty || 'Type établissement') + ' : ' + (data.property || '—'),
      (data.labelCategory || 'Catégorie') + ' : ' + (data.category || '—'),
      (data.labelQuantity || 'Quantité') + ' : ' + (data.quantity || '—'),
      (data.labelLogo || 'Personnalisation logo') + ' : ' + (data.logo || '—'),
      '',
      (data.labelMessage || 'Message') + ' :',
      data.message || '—'
    ];
    return lines.join('\n');
  }

  function sendViaWebhook(config, data, html, subject) {
    var payloadObj = {
      to: config.recipient || DEFAULT_RECIPIENT,
      subject: subject,
      replyTo: data.email || '',
      fields: data
    };

    if (config.recipient2) {
      payloadObj.to2 = config.recipient2;
    }

    var payloadJson = JSON.stringify(payloadObj);
    var url = config.webhookUrl;

    return new Promise(function (resolve) {
      var frameId = 'MpQuoteGasFrame';
      var frame = document.getElementById(frameId);

      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = frameId;
        frame.name = frameId;
        frame.setAttribute('tabindex', '-1');
        frame.setAttribute('aria-hidden', 'true');
        frame.style.cssText =
          'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;border:0;left:-9999px;top:0;';
        document.body.appendChild(frame);
      }

      var gasForm = document.createElement('form');
      gasForm.method = 'POST';
      gasForm.action = url;
      gasForm.target = frameId;
      gasForm.style.display = 'none';

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'payload';
      input.value = payloadJson;
      gasForm.appendChild(input);
      document.body.appendChild(gasForm);

      var settled = false;

      function finish() {
        if (settled) return;
        settled = true;
        if (gasForm.parentNode) gasForm.parentNode.removeChild(gasForm);
        resolve();
      }

      var timer = global.setTimeout(finish, 10000);

      frame.onload = function () {
        global.clearTimeout(timer);
        finish();
      };

      gasForm.submit();
    });
  }

  function sendViaEmailJs(config, data, html, subject) {
    if (!config.publicKey || !config.serviceId || !config.templateId) {
      return Promise.reject(new Error('emailjs_not_configured'));
    }
    if (typeof global.emailjs === 'undefined') {
      return Promise.reject(new Error('emailjs_missing'));
    }

    global.emailjs.init(config.publicKey);

    var payload = {
      to_email: config.recipient || '',
      reply_to: data.email || '',
      from_name: data.name || 'Client MP Amenities',
      subject: subject,
      message: html
    };

    var sends = [global.emailjs.send(config.serviceId, config.templateId, payload)];

    if (config.recipient2) {
      sends.push(
        global.emailjs.send(config.serviceId, config.templateId, Object.assign({}, payload, { to_email: config.recipient2 }))
      );
    }

    return Promise.all(sends);
  }

  function send(config, data) {
    if (!config) return Promise.resolve();

    var html = buildHtml(data);
    var subject = (data.subject || 'Nouvelle demande de devis') + (data.name ? ' — ' + data.name : '');

    if (config.webhookUrl) {
      return sendViaWebhook(config, data, html, subject);
    }

    if (!config.enabled) return Promise.resolve();

    return sendViaEmailJs(config, data, html, subject);
  }

  global.MpQuoteEmail = {
    buildHtml: buildHtml,
    send: send
  };
})(window);
